export const GET_RECURRING_PAYABLES_REQUEST = 'GET_RECURRING_PAYABLES_REQUEST';
export const GET_RECURRING_PAYABLES_SUCCESS = 'GET_RECURRING_PAYABLES_SUCCESS';
export const GET_RECURRING_PAYABLES_FAILURE = 'GET_RECURRING_PAYABLES_FAILURE';

export const POST_RECURRING_PAYABLES_REQUEST = 'POST_RECURRING_PAYABLES_REQUEST';
export const POST_RECURRING_PAYABLES_SUCCESS = 'POST_RECURRING_PAYABLES_SUCCESS';
export const POST_RECURRING_PAYABLES_FAILURE = 'POST_RECURRING_PAYABLES_FAILURE';

export const UPDATE_RECURRING_PAYABLES_REQUEST = 'UPDATE_RECURRING_PAYABLES_REQUEST';
export const UPDATE_RECURRING_PAYABLES_SUCCESS = 'UPDATE_RECURRING_PAYABLES_SUCCESS';
export const UPDATE_RECURRING_PAYABLES_FAILURE = 'UPDATE_RECURRING_PAYABLES_FAILURE';

export const DELETE_RECURRING_PAYABLES_REQUEST = 'DELETE_RECURRING_PAYABLES_REQUEST';
export const DELETE_RECURRING_PAYABLES_SUCCESS = 'DELETE_RECURRING_PAYABLES_SUCCESS';
export const DELETE_RECURRING_PAYABLES_FAILURE = 'DELETE_RECURRING_PAYABLES_FAILURE';

export const GET_RECURRING_PAYABLE_REQUEST = 'GET_RECURRING_PAYABLE_REQUEST';
export const GET_RECURRING_PAYABLE_SUCCESS = 'GET_RECURRING_PAYABLE_SUCCESS';
export const GET_RECURRING_PAYABLE_FAILURE = 'GET_RECURRING_PAYABLE_FAILURE';

export const POST_RP_LINEITEM_REQUEST = 'POST_RP_LINEITEM_REQUEST';
export const POST_RP_LINEITEM_SUCCESS = 'POST_RP_LINEITEM_SUCCESS';
export const POST_RP_LINEITEM_FAILURE = 'POST_RP_LINEITEM_FAILURE';

export const PUT_RP_LINEITEM_REQUEST = 'PUT_RP_LINEITEM_REQUEST';
export const PUT_RP_LINEITEM_SUCCESS = 'PUT_RP_LINEITEM_SUCCESS';
export const PUT_RP_LINEITEM_FAILURE = 'PUT_RP_LINEITEM_FAILURE';

export const DELETE_RP_LINEITEM_REQUEST = 'DELETE_RP_LINEITEM_REQUEST';
export const DELETE_RP_LINEITEM_SUCCESS = 'DELETE_RP_LINEITEM_SUCCESS';
export const DELETE_RP_LINEITEM_FAILURE = 'DELETE_RP_LINEITEM_FAILURE';

export const POST_RP_ATTACHMENT_REQUEST = 'POST_RP_ATTACHMENT_REQUEST';
export const POST_RP_ATTACHMENT_SUCCESS = 'POST_RP_ATTACHMENT_SUCCESS';
export const POST_RP_ATTACHMENT_FAILURE = 'POST_RP_ATTACHMENT_FAILURE';

export const UPDATE_RP_ATTACHMENT_REQUEST = 'UPDATE_RP_ATTACHMENT_REQUEST';
export const UPDATE_RP_ATTACHMENT_SUCCESS = 'UPDATE_RP_ATTACHMENT_SUCCESS';
export const UPDATE_RP_ATTACHMENT_FAILURE = 'UPDATE_RP_ATTACHMENT_FAILURE';

export const DELETE_RP_ATTACHMENT_REQUEST = 'DELETE_RP_ATTACHMENT_REQUEST';
export const DELETE_RP_ATTACHMENT_SUCCESS = 'DELETE_RP_ATTACHMENT_SUCCESS';
export const DELETE_RP_ATTACHMENT_FAILURE = 'DELETE_RP_ATTACHMENT_FAILURE';

export const POST_RP_LINE_ATTACHMENT_REQUEST = 'POST_RP_LINE_ATTACHMENT_REQUEST';
export const POST_RP_LINE_ATTACHMENT_SUCCESS = 'POST_RP_LINE_ATTACHMENT_SUCCESS';
export const POST_RP_LINE_ATTACHMENT_FAILURE = 'POST_RP_LINE_ATTACHMENT_FAILURE';

export const DELETE_RP_LINE_ATTACHMENT_REQUEST = 'DELETE_RP_LINE_ATTACHMENT_REQUEST';
export const DELETE_RP_LINE_ATTACHMENT_SUCCESS = 'DELETE_RP_LINE_ATTACHMENT_SUCCESS';
export const DELETE_RP_LINE_ATTACHMENT_FAILURE = 'DELETE_RP_LINE_ATTACHMENT_FAILURE';

export const GENERATE_RP_PAYMENT_SCHEDULE_REQUEST = 'GENERATE_RP_PAYMENT_SCHEDULE_REQUEST';
export const GENERATE_RP_PAYMENT_SCHEDULE_SUCCESS = 'GENERATE_RP_PAYMENT_SCHEDULE_SUCCESS';
export const GENERATE_RP_PAYMENT_SCHEDULE_FAILURE = 'GENERATE_RP_PAYMENT_SCHEDULE_FAILURE';
